import { useMemo } from 'react';
import { r as reactResponsive } from '../../node_modules/react-responsive/dist/react-responsive.js';
import { useTheme } from '../../hooks/useTheme.js';

function getResponsiveQueries(_a) {
    var _b, _c, _d, _e;
    var theme = _a.theme, min = _a.min, max = _a.max;
    var minWidth;
    var maxWidth;
    if (min) {
        var breakpointIdx = (_b = theme.namedBreakpointIndexes) === null || _b === void 0 ? void 0 : _b[min];
        if (breakpointIdx !== undefined && breakpointIdx >= 0) {
            minWidth = ((_c = theme.breakpoints) === null || _c === void 0 ? void 0 : _c[breakpointIdx - 1]) || "0px";
        }
        else {
            minWidth = "0px";
        }
    }
    if (max) {
        var breakpointIdx = (_d = theme.namedBreakpointIndexes) === null || _d === void 0 ? void 0 : _d[max];
        if (breakpointIdx !== undefined && breakpointIdx >= 0) {
            maxWidth = (_e = theme.breakpoints) === null || _e === void 0 ? void 0 : _e[breakpointIdx];
        }
    }
    if (!minWidth && !maxWidth)
        minWidth = "0px";
    return { minWidth: minWidth, maxWidth: maxWidth };
}
var useResponsiveReact = function (_a) {
    var min = _a.min, max = _a.max;
    var theme = useTheme().theme;
    var queries = useMemo(function () { return getResponsiveQueries({ theme: theme, min: min, max: max }); }, [theme, min, max]);
    return reactResponsive.useMediaQuery(queries);
};

export { useResponsiveReact };
//# sourceMappingURL=useResponsiveReact.js.map
